// BrightCore PR Mock Data - Bilingual Content

export const content = {
  es: {
    nav: {
      services: 'Servicios',
      portfolio: 'Portafolio',
      about: 'Nosotros',
      contact: 'Contacto'
    },
    hero: {
      headline: 'Impulsamos tu presencia digital en Puerto Rico',
      subheadline: 'Websites, Apps, Software & Digital Solutions para negocios modernos',
      cta1: 'Contáctanos',
      cta2: 'Ver Portafolio'
    },
    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Soluciones digitales completas para tu negocio',
      items: [
        { id: 1, title: 'Diseño Web', description: 'Interfaces modernas y atractivas que cautivan a tus usuarios', icon: 'Palette' },
        { id: 2, title: 'Desarrollo Web', description: 'Sitios web robustos, rápidos y escalables', icon: 'Code' },
        { id: 3, title: 'Apps iOS & Android', description: 'Aplicaciones móviles nativas y multiplataforma', icon: 'Smartphone' },
        { id: 4, title: 'Frontend Development', description: 'Experiencias de usuario interactivas y fluidas', icon: 'Layout' },
        { id: 5, title: 'Backend Development', description: 'APIs y sistemas robustos para tu negocio', icon: 'Server' },
        { id: 6, title: 'UI/UX Design', description: 'Diseños centrados en el usuario para máxima conversión', icon: 'Figma' },
        { id: 7, title: 'E-commerce', description: 'Tiendas online optimizadas para ventas', icon: 'ShoppingCart' },
        { id: 8, title: 'SEO Optimization', description: 'Mejora tu visibilidad en motores de búsqueda', icon: 'Search' },
        { id: 9, title: 'Branding & Identidad', description: 'Crea una marca memorable y profesional', icon: 'Sparkles' },
        { id: 10, title: 'API Integrations', description: 'Conecta tus sistemas con servicios externos', icon: 'Plug' },
        { id: 11, title: 'Automatización', description: 'Optimiza procesos con sistemas inteligentes', icon: 'Zap' },
        { id: 12, title: 'Hosting & Dominios', description: 'Soluciones de hosting confiables y seguras', icon: 'Globe' },
        { id: 13, title: 'Mantenimiento & Soporte', description: 'Soporte continuo para tu tranquilidad', icon: 'Wrench' }
      ]
    },
    portfolio: {
      title: 'Nuestro Trabajo',
      subtitle: 'Proyectos que transforman negocios',
      comingSoon: 'Próximamente',
      viewProject: 'Ver Proyecto',
      items: [
        { 
          id: 1, 
          name: 'Bright Little Minds', 
          category: 'iOS & Android App', 
          description: 'App educativa con cuentos interactivos, juegos adaptados por edad e historias personalizadas con IA. 100% segura, sin anuncios.',
          image: 'https://customer-assets.emergentagent.com/job_learnplay-61/artifacts/h2r9t550_HomePage_iPad.png',
          url: 'https://brightlittleminds.app'
        },
        { 
          id: 2, 
          name: 'HR Consulting Platform', 
          category: 'Website & Plataforma', 
          description: 'Soluciones estratégicas en recursos humanos. Consultoría, adiestramientos y outsourcing de HR con enfoque en cumplimiento.',
          image: 'https://static.prod-images.emergentagent.com/jobs/a3ce0aed-8682-429f-afc6-2bab3d5f4a96/images/bf68f8b15d40b28d48672126820de63b1e9381cdd7cbb99fb75f33f6154fddc6.png',
          url: 'https://hr.brightcorepr.com'
        }
      ]
    },
    whyUs: {
      title: '¿Por qué BrightCore PR?',
      subtitle: 'Tu socio digital de confianza en Puerto Rico',
      items: [
        { id: 1, title: 'Basados en Puerto Rico', description: 'Conocemos el mercado local y sus necesidades', icon: 'MapPin' },
        { id: 2, title: 'Tecnologías Modernas', description: 'Utilizamos las últimas herramientas y frameworks', icon: 'Cpu' },
        { id: 3, title: 'Soluciones Personalizadas', description: 'Cada proyecto es único, adaptado a tus necesidades', icon: 'Settings' },
        { id: 4, title: 'Entrega Rápida', description: 'Cumplimos con los plazos establecidos', icon: 'Clock' },
        { id: 5, title: 'Enfoque en Resultados', description: 'Diseñamos para convertir visitantes en clientes', icon: 'Target' },
        { id: 6, title: 'Sistemas Escalables', description: 'Soluciones que crecen con tu negocio', icon: 'TrendingUp' }
      ]
    },
    contact: {
      title: 'Contáctanos',
      subtitle: 'Hablemos sobre tu próximo proyecto',
      form: {
        name: 'Nombre',
        email: 'Correo Electrónico',
        phone: 'Teléfono',
        message: 'Mensaje',
        submit: 'Enviar Mensaje',
        success: '¡Mensaje enviado exitosamente!',
        error: 'Error al enviar el mensaje. Por favor intenta de nuevo.'
      },
      info: {
        location: 'Vega Alta, Puerto Rico',
        phone: '787-410-3627',
        email: 'contact@brightcorepr.com'
      }
    },
    footer: {
      slogan: 'Powering Your Digital Vision',
      copyright: '© 2025 BrightCore PR. Todos los derechos reservados.',
      privacy: 'Política de Privacidad',
      terms: 'Términos y Condiciones'
    }
  },
  en: {
    nav: {
      services: 'Services',
      portfolio: 'Portfolio',
      about: 'About',
      contact: 'Contact'
    },
    hero: {
      headline: 'We power your digital presence in Puerto Rico',
      subheadline: 'Websites, Apps, Software & Digital Solutions for modern businesses',
      cta1: 'Contact Us',
      cta2: 'View Portfolio'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Complete digital solutions for your business',
      items: [
        { id: 1, title: 'Web Design', description: 'Modern and attractive interfaces that captivate your users', icon: 'Palette' },
        { id: 2, title: 'Web Development', description: 'Robust, fast, and scalable websites', icon: 'Code' },
        { id: 3, title: 'iOS & Android Apps', description: 'Native and cross-platform mobile applications', icon: 'Smartphone' },
        { id: 4, title: 'Frontend Development', description: 'Interactive and fluid user experiences', icon: 'Layout' },
        { id: 5, title: 'Backend Development', description: 'APIs and robust systems for your business', icon: 'Server' },
        { id: 6, title: 'UI/UX Design', description: 'User-centered designs for maximum conversion', icon: 'Figma' },
        { id: 7, title: 'E-commerce', description: 'Online stores optimized for sales', icon: 'ShoppingCart' },
        { id: 8, title: 'SEO Optimization', description: 'Improve your visibility in search engines', icon: 'Search' },
        { id: 9, title: 'Branding & Identity', description: 'Create a memorable and professional brand', icon: 'Sparkles' },
        { id: 10, title: 'API Integrations', description: 'Connect your systems with external services', icon: 'Plug' },
        { id: 11, title: 'Automation', description: 'Optimize processes with intelligent systems', icon: 'Zap' },
        { id: 12, title: 'Hosting & Domains', description: 'Reliable and secure hosting solutions', icon: 'Globe' },
        { id: 13, title: 'Maintenance & Support', description: 'Ongoing support for your peace of mind', icon: 'Wrench' }
      ]
    },
    portfolio: {
      title: 'Our Work',
      subtitle: 'Projects that transform businesses',
      comingSoon: 'Coming Soon',
      viewProject: 'View Project',
      items: [
        { 
          id: 1, 
          name: 'Bright Little Minds', 
          category: 'iOS & Android App', 
          description: 'Educational app with interactive stories, age-adapted games, and AI-personalized stories. 100% safe, ad-free.',
          image: 'https://customer-assets.emergentagent.com/job_learnplay-61/artifacts/h2r9t550_HomePage_iPad.png',
          url: 'https://brightlittleminds.app'
        },
        { 
          id: 2, 
          name: 'HR Consulting Platform', 
          category: 'Website & Platform', 
          description: 'Strategic human resources solutions. HR consulting, training, and outsourcing with compliance focus.',
          image: 'https://static.prod-images.emergentagent.com/jobs/a3ce0aed-8682-429f-afc6-2bab3d5f4a96/images/bf68f8b15d40b28d48672126820de63b1e9381cdd7cbb99fb75f33f6154fddc6.png',
          url: 'https://hr.brightcorepr.com'
        }
      ]
    },
    whyUs: {
      title: 'Why BrightCore PR?',
      subtitle: 'Your trusted digital partner in Puerto Rico',
      items: [
        { id: 1, title: 'Puerto Rico Based', description: 'We know the local market and its needs', icon: 'MapPin' },
        { id: 2, title: 'Modern Technologies', description: 'We use the latest tools and frameworks', icon: 'Cpu' },
        { id: 3, title: 'Custom Solutions', description: 'Each project is unique, tailored to your needs', icon: 'Settings' },
        { id: 4, title: 'Fast Delivery', description: 'We meet established deadlines', icon: 'Clock' },
        { id: 5, title: 'Results Focused', description: 'We design to convert visitors into customers', icon: 'Target' },
        { id: 6, title: 'Scalable Systems', description: 'Solutions that grow with your business', icon: 'TrendingUp' }
      ]
    },
    contact: {
      title: 'Contact Us',
      subtitle: "Let's talk about your next project",
      form: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        message: 'Message',
        submit: 'Send Message',
        success: 'Message sent successfully!',
        error: 'Error sending message. Please try again.'
      },
      info: {
        location: 'Vega Alta, Puerto Rico',
        phone: '787-410-3627',
        email: 'contact@brightcorepr.com'
      }
    },
    footer: {
      slogan: 'Powering Your Digital Vision',
      copyright: '© 2025 BrightCore PR. All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms & Conditions'
    }
  }
};

export const logoUrl = 'https://customer-assets.emergentagent.com/job_brightcore-web/artifacts/j1tbrj23_B50D3E38-5FA5-4018-895B-80E6B505B846.png';
